import { render } from "./ModuleOrMenu.vue?vue&type=template&id=2a0932b3&scoped=true"
import script from "./ModuleOrMenu.vue?vue&type=script&lang=js"
export * from "./ModuleOrMenu.vue?vue&type=script&lang=js"

import "./ModuleOrMenu.vue?vue&type=style&index=0&id=2a0932b3&scoped=true&lang=css"

import exportComponent from "D:\\xampp7\\htdocs\\24x7pos\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a0932b3"]])

export default __exports__